<template>
  <div v-if="env !== 'prod'">
    <HeaderModule
      v-if="!$route.params.id"
      title="Dev Ops"
      icon="git"
      description="Tech Team Only!"
      padding="10px"
      :tabs="tabs"
      width="100%"
    >
      <template #feTesting>
        <FETesting ref="feTesting" />
      </template>

      <template #analytics>
        <LIAnalytics ref="analytics" />
      </template>

      <template #devopsLogs>
        <DevopsLogs ref="devopsLogs" />
      </template>

      <template #deploy>
        <Deploy ref="deploy" />
      </template>

      <template #ai>
        <Ai ref="ai" />
      </template>
    </HeaderModule>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import HeaderModule from "@/components/HeaderModule.vue";
import Deploy from "@/components/Deploy.vue";
import DevopsLogs from "@/components/DevopsLogs.vue";
import FETesting from "@/components/FETesting.vue";
import Ai from "@/components/Ai.vue";
import LIAnalytics from "@/components/LIAnalytics.vue";
import { systemMessages } from "@/mixins/SystemMessages";

export default {
  name: "DevOpsPage",
  mixins: [systemMessages],
  components: {
    HeaderModule,
    Deploy,
    FETesting,
    Ai,
    LIAnalytics,
    DevopsLogs,
  },
  props: {
    selectedTabRoute: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    env: process.env.VUE_APP_ENVIRONMENT,
    tabs: [
      { title: "FE Testing", value: "feTesting", route: "fe-testing" },
      { title: "Analytics", value: "analytics", route: "analytics" },
      { title: "Logs", value: "devopsLogs", route: "devops-logs" },
      { title: "Deploy", value: "deploy", route: "deploy" },
      { title: "AI", value: "ai", route: "ai" },
    ],
  }),
  created() {
    // this.stuff();
  },
  methods: {},
};
</script>

<style scoped></style>
